import {Component, HostBinding, Input} from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-score',
    templateUrl: './ds-score.component.html',
    styleUrls: ['./ds-score.component.scss'],
    standalone: false
})
export class DsScoreComponent {

  public radius: number = 2 * Math.PI * 18;
  @Input() loading: boolean = false;
  @Input() error: boolean = false;
  @Input() withShadow: boolean = true;
  @Input() score: number;
  @Input() lineWidth?: number = 4;
  @Input() size?: 's' | 'm' | 'l' = 's';
  @Input() gray: boolean = false;
  @Input() thin: boolean = false;
  @HostBinding('style.z-index') @Input() zIndex?: number;
  @HostBinding('style.position') @Input() position?: 'relative' | 'absolute' | 'static' | 'fixed' = 'static';
  @HostBinding('style.top.px') @Input() y?: number | string = 0;
  @HostBinding('style.left.px') @Input() x?: number | string = 0;

}
